// TODO: When we add the shared lib/ package, these should be moved there.
// Just putting them here for now since this is the only package shared by
// both API and UI.

export const USIO_EMAIL = 'cs@akimbocard.com';
export const USIO_PHONE = '+18554492273';
export const USIO_PORTAL_URL = 'https://app.akimbocard.com/app/#/nowincentive/login';
